import axios from "axios";
import { url } from "./baseUrl.js";

const axiosInstance = axios.create({
  baseURL: `${url}/api`,
  withCredentials: true,
});

export default axiosInstance;
